/**
 * SB5-B.2 — Pricing placeholder (Q15).
 *
 * The pricing JSONB schema is not yet defined. Per Q15, render a
 * read-only placeholder. PATCH endpoint accepts `pricing` for forward
 * compatibility but the FE doesn't expose it for editing in PR1.
 */
import { type ReactElement } from "react";
import { Paper, Typography } from "@mui/material";

export function PricingPlaceholder(): ReactElement {
  return (
    <Paper variant="outlined" sx={{ p: 2 }} data-testid="pricing-placeholder">
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ display: "block", mb: 1 }}
      >
        Pricing
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Pricing structure not yet defined — editing will be available in a
        future release.
      </Typography>
    </Paper>
  );
}
